<template>
  <div class="about-me">
    <div class="card-container">
      <div class="columns is-gapless">
        <div class="column is-5">
          <div class="img-container">
            <img src="@/assets/profile.webp" alt="Profile Picture" />
          </div>
        </div>
        <div class="column is-7">
          <div class="description-container">
            <h1 class="main-title">{{ $t("about.title") }}</h1>
            <p class="paragraph">{{ $t("about.greeting") }}</p>
            <p class="paragraph" v-html="$t('about.experience_intro', { years })"></p>
            <p class="paragraph">{{ $t("about.past_experience") }}</p>
            <p class="paragraph">{{ $t("about.self_perception") }}</p>

            <h2 class="focus-title">{{ $t("about.focus_title") }}</h2>
            <ul class="focus-list">
              <li v-for="(point, index) in $t('about.focus_points')" :key="index" class="focus-item">
                {{ point }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import moment from 'moment';

export default {
  name: "AboutMe",
  components: {},
  data() {
    return {
      years: 4
    }
  },
  created() {
    this.setExperienceTime();
  },
  methods: {
    setExperienceTime() {
      this.years = moment().utcOffset(-3).diff('2016-05-01', 'years');
    }
  }
};
</script>
<style lang="scss" scoped>
div.about-me {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem 0;
  background-color: #f8f9fa;

  div.card-container {
    width: 90vw;
    max-width: 900px;
    background-color: #ffffff;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    overflow: hidden;

    div.columns {
      height: 100%;
    }

    div.description-container {
      font-family: "Raleway", sans-serif;
      padding: 2rem 2.5rem;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      color: #343a40;

      @media(max-width: 768px) {
        padding: 1.5rem;
      }

      h1.main-title {
        font-size: 2rem;
        font-weight: bold;
        color: #2c3e50;
        margin-bottom: 1.5rem;
        text-align: left;
      }

      p.paragraph {
        text-align: left;
        font-size: 0.95rem;
        line-height: 1.7;
        margin-bottom: 1rem;

        &:last-of-type {
          margin-bottom: 1.5rem;
        }
      }

      h2.focus-title {
        font-size: 1.25rem;
        font-weight: bold;
        color: #2c3e50;
        margin-top: 1rem;
        margin-bottom: 0.75rem;
        text-align: left;
      }

      ul.focus-list {
        list-style: none;
        padding-left: 0;
        text-align: left;
        margin-bottom: 1rem;

        li.focus-item {
          font-size: 0.95rem;
          line-height: 1.6;
          margin-bottom: 0.5rem;
          position: relative;
          padding-left: 1.5em;

          &::before {
            content: "*";
            color: #007bff; // Accent color for bullets
            position: absolute;
            left: 0;
            font-weight: bold;
          }
        }
      }
    }
  }

  @media (min-width: 769px) {
    div.card-container {
      display: flex;

      div.columns {
        width: 100%;
      }

      div.img-container {
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: #e9ecef;
        padding: 1rem;

        img {
          max-width: 100%;
          height: auto;
          max-height: 400px;
          border-radius: 6px;
          object-fit: cover; // Ensures image covers the area, cropping if necessary
        }
      }
    }
  }

  @media (max-width: 768px) {
    div.card-container {
      div.columns {
        display: flex;
        flex-direction: column;

        .column.is-5 {
          // Image column
          order: -1; // Display image above text on mobile
          width: 100%;

          div.img-container {
            padding: 0;

            img {
              width: 100%;
              height: auto;
              border-radius: 8px 8px 0 0; // Round top corners only on mobile
              object-fit: cover;
            }
          }
        }

        .column.is-7 {
          // Text column
          width: 100%;
        }
      }
    }
  }
}
</style>
